<template>
	<div id="jingmaiExam">
		<div class="el-tabs el-tabs--left">
			<div class="el-tabs__header is-left">
				<div class="el-tabs__nav-wrap is-left">
					<div class="el-tabs__nav-scroll">
						<div class="el-tabs__nav is-left">
							<div class="el-tabs__active-bar is-left" style="height: 50px; transform: translateY(0px);"></div>
							<div id="tab-first" class="el-tabs__item js-tab is-left is-active">
								<div class="tab-slot">
									<p class="title">1、登录京麦</p>
								</div>
							</div>
							<div id="tab-second" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">2、状态切换</p>
								</div>
							</div>
							<div id="tab-third" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">3、客户列表+数据统计</p>
								</div>
							</div>
							<div id="tab-four" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">4、自动回复设置</p>
								</div>
							</div>
							<div id="tab-five" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">5、快捷短语导入和使用</p>
								</div>
							</div>
							<div id="tab-six" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">6、转接功能</p>
								</div>
							</div>
							<div id="tab-seven" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">7、插件功能（上）</p>
								</div>
							</div>
							<div id="tab-eight" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">7、插件功能（下）</p>
								</div>
							</div>
							<div id="tab-nine" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">8、退出京麦</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="el-tabs__content">
				<div id="tab-first-content" class="el-tab-pane">
					<div id="stoptip-first" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-first" class="content">
						<div class="con-left">
							<!--双击图标-->
							<div v-show="isShowQnIcon" class="qnbox">
								<img class="qnbg" src="@/assets/images/jingmai/bg.png" />
								<img class="qnicon01" src="@/assets/images/jingmai/logo01.png" @click="showLoginImg" />
							</div>
							<div v-show="isShowQnIcon2" class="qnbox">
								<img class="qnbg" src="@/assets/images/jingmai/bg.png" />
								<img class="qnicon02" src="@/assets/images/jingmai/logo02.png" @dblclick="showLoginImg2" />
							</div>
							<!--登录-->
							<div v-show="isShowLoginImg" class="login">
					      <img src="@/assets/images/jingmai/login.png" class="homeImg">
					      <input type="text" v-model="name" class="name" placeholder="请输入账号" />
					      <input type="password" v-model="password" autocomplete="new-password" class="password" placeholder="请输入密码" />
					      <div class="mima" @click="isShowMimaImg = true"></div>
					      <img class="mima" v-show="isShowMimaImg" src="@/assets/images/jingmai/mima.png" />
					      <div class="logIn" @click="loginIn"></div>
					    </div>
							<!--获取随机码-->
							<div v-show="isShowRnd" class="loginrnd">
								<img src="@/assets/images/jingmai/loginrnd.png" class="rndImg">
					      <input type="text" v-model="rnd" class="rnd" placeholder="请输入短信验证码" />
					      <div class="logInRnd" @click="loginInRnd"></div>
							</div>
							<!--登录成功点击会话图标-->
							<div v-show="isShowLoginIndex" class="jdbox">
								<img class="jdimg" src="@/assets/images/jingmai/index.png" />
								<div class="jdicon" @click="enterJd"></div>
							</div>
							<!--完成-->
							<div v-show="isShowLoginIndexTwo" class="indexbox">
								<img class="indeximg" src="@/assets/images/jingmai/jd.png" />
							</div>
						</div>
						<div class="con-right">
							<h3>
								<span class="line"></span>
								提示
							</h3>
							<!--双击图标-->
							<p v-if="isShowQnIcon || isShowQnIcon2">请点击<span style="color: red;font-weight:bold;">左侧练习场</span>中的京麦图标进行登录</p>
							<!--登录-->
							<template v-if="isShowLoginImg">
								<p>首次登录需要找主管获取账号密码。本次模拟练习，请点击下方按钮获取账号密码。</p>
								<el-button type="primary" @click="showPassword = true">获取账号密码</el-button>
								<template v-if="showPassword">
									<p>账号（<font color="red">账号中间的冒号是英文冒号</font>）：</p>
									<p><font color="red">淘金客服:002</font></p>
									<p>密码：</p>
									<p><font color="red">TJ2022</font></p>
									<p>勾选“记住密码”</p>
								</template>
							</template>
							<!--获取随机码-->
							<template v-if="isShowRnd">
								<p>首次登录需要找主管获取短信验证码。本次模拟练习，请点击下方按钮获取短信验证码。</p>
								<el-button type="primary" @click="showRnd = true">获取短信验证码</el-button>
								<template v-if="showRnd">
									<p>短信验证码：</p>
									<p><font color="red">6022</font></p>
								</template>
							</template>
							<!--进入接待中心-->	
							<p v-if="isShowLoginIndex">请进入京麦接待中心</p>
						</div>
					</div>
					<div id="studytip-first" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>实操通关，进入下一关吧</p>
							<p>
								<a class="startstudy" @click="studyNext('#tab-second', 2, 'second')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>
				<div id="tab-second-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'second'}">
					<div id="stoptip-second" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-second" class="content">
						<div class="con-left">
							<!--挂起-->
							<div v-show="!isShowWgq" class="gqbox">
								<img class="gqimg" src="@/assets/images/jingmai/jd.png" />
								<div class="gqbtn" @click="showGqImg = true"></div>
								<img v-show="showGqImg" class="gqimg" src="@/assets/images/jingmai/qh.png" />
								<div v-show="showGqImg" class="gqclick" @click="showWgqImg" />
							</div>
							<!--在线-->
							<div class="wgqbox" v-show="isShowWgq">
								<img class="wgqimg" src="@/assets/images/jingmai/qhwc.png" />
							</div>
						</div>
						<div class="con-right">
							<h3>
								<span class="line"></span>
								提示
							</h3>
							<p>请将状态切换为“在线”</p>
						</div>
					</div>
					<div id="studytip-second" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>实操通关，进入下一关吧</p>
							<p>
								<a class="startstudy" @click="studyNext('#tab-third', 3, 'third')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>
				<div id="tab-third-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'third'}">
					<div id="stoptip-third" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-third" class="content">
						<div class="con-left">
							<!--排序-->
							<div class="paixubox">
								<img v-show="isShowOne || isShowFive" class="pximg" src="@/assets/images/jingmai/paixu01.png" />
								<div v-show="isShowOne" class="pxbtn" @mouseover="showPaixuImgOne"></div>
								<img v-show="isShowTwo" class="pximg" src="@/assets/images/jingmai/paixu02.png" />
								<div v-show="isShowTwo" class="pxbtn" @click="showPaixuImgTwo"></div>
								<img v-show="isShowThree" class="pximg" src="@/assets/images/jingmai/paixu03.png" />
								<div v-show="isShowThree" class="pxclick" @mouseover="showPaixuImgThree" />
								<img v-show="isShowFour" class="pximg" src="@/assets/images/jingmai/paixu04.png" />
								<div v-show="isShowFour" class="pxclick" @click="showPaixuImgFour" />
								<div v-show="isShowFive" class="sjclick" @click="showPaixuImgFive" />
								<img v-show="isShowSix" class="pximg" src="@/assets/images/jingmai/paixu05.png" />
							</div>
						</div>
						<div class="con-right">
							<h3>
								<span class="line"></span>
								提示
							</h3>
							<p v-if="isShowOne || isShowTwo || isShowThree || isShowFour">请将客户咨询排序设置为“<font color="red">按等待时间降序</font>”</p>
							<p v-if="isShowFive">请切换到<font color="red">数据</font>功能，查看数据</p>
						</div>
					</div>
					<div id="studytip-third" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>实操通关，进入下一关吧</p>
							<p>
								<a class="startstudy" @click="studyNext('#tab-four', 4, 'four')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>
				<div id="tab-four-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'four'}">
					<div id="stoptip-four" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-four" class="content">
						<div class="con-left">
							<div class="zdhfbox">
								<img class="gqimg" v-show="isShowZdhficon" src="@/assets/images/jingmai/zdhf01.png" />
								<div class="zdhficon" v-show="isShowZdhficon" @mouseover="showZdhf01"></div>
								<img class="gqimg" v-show="isShowZdhf01" src="@/assets/images/jingmai/zdhf02.png" />
								<div class="zdhficon" v-show="isShowZdhf01" @click="showZdhf02"></div>
								<img class="gqimg" v-show="isShowZdhf02" src="@/assets/images/jingmai/zdhf03.png" />
								<div class="zdhf01icon" v-show="isShowZdhf02" @click="showZdhf03"></div>
								<div class="zdhf02" v-show="isShowZdhf03">
									<img src="@/assets/images/jingmai/zdhf04.png" />
									<div class="zdhf02icon" @click="showZdhf04"></div>
								</div>
								<div class="zdhf02" v-show="isShowZdhf04">
									<img src="@/assets/images/jingmai/zdhf05.png" />
									<div class="zdhf03icon" @click="showZdhf05"></div>
								</div>
								<div class="zdhf02" v-show="isShowZdhf05">
									<img src="@/assets/images/jingmai/zdhf06.png" />
									<div class="zdhf04icon" @click="showZdhf06"></div>
								</div>
								<div class="zdhf02" v-show="isShowZdhf06">
									<img src="@/assets/images/jingmai/zdhf07.png" />
									<div class="zdhf05icon" @click="showZdhf07"></div>
								</div>
								<div class="zdhf02" v-show="isShowZdhf07">
									<img src="@/assets/images/jingmai/zdhf08_bg.png" />
									<img class="scrollImg" src="@/assets/images/jingmai/zdhf08.png" />
									<el-input class="zdhf06input" v-model="zdhf" type="textarea"></el-input>
									<div class="zdhf06icon" @click="showZdhf08"></div>
								</div>
								<div class="zdhf02" v-show="isShowZdhf08">
									<img src="@/assets/images/jingmai/zdhf09.png" />
								</div>
							</div>
						</div>
						<div class="con-right">
							<h3>
								<span class="line"></span>
								提示
							</h3>
							<p>请设置“您好！欢迎光临，请问有什么可以帮到您？”的自动回复<font color="red">个人版欢迎语</font>，并勾选“<font color="red">第一次收到顾客消息的回复语</font>”（记得保存）</p>
						</div>
					</div>
					<div id="studytip-four" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>实操通关，进入下一关吧</p>
							<p>
								<a class="startstudy" @click="studyNext('#tab-five', 5, 'five')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>
				<div id="tab-five-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'five'}">
					<div id="stoptip-five" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-five" class="content">
						<div class="con-left">
							<div class="kjdybox">
								<!--导入-->
								<div class="kjdy" v-show="isShowKjdy01">
									<img src="@/assets/images/jingmai/kjdy01.png" />
									<div class="kjdy01icon" @mouseover="showKjdy01"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy02">
									<img src="@/assets/images/jingmai/kjdy02.png" />
									<div class="kjdy01icon">
										<input type="file" @change="tirggerFile($event)" accept=".csv" class="btn-file" />
									</div>
								</div>
								<div class="kjdy" v-show="isShowKjdy03">
									<img src="@/assets/images/jingmai/kjdy03.png" />
								</div>
								<!--鼠标调出快捷短语-->
								<div class="kjdy" v-show="isShowKjdy04">
									<img src="@/assets/images/jingmai/kjdy04.png" />
									<div class="kjdy02icon" @mouseover="showKjdy02"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy05">
									<img src="@/assets/images/jingmai/kjdy05.png" />
									<div class="kjdy03icon" @click="showKjdy03"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy06">
									<img src="@/assets/images/jingmai/kjdy06.png" />
									<input type="text" class="kjdyinput" v-focus="true" @keyup.enter="showKjdy04">
									<div class="kjdy04icon" @click="showKjdy04"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy07">
									<img src="@/assets/images/jingmai/kjdy07.png" />
								</div>
								<!--输入/16调出快捷短语-->
								<div class="kjdy" v-show="isShowKjdy08">
									<img src="@/assets/images/jingmai/kjdy04.png" />
									<div class="kjdy05icon">
										<el-input type="textarea" v-model="kjdy" class="kjdy01input"></el-input>
									</div>
								</div>
								<div class="kjdy" v-show="isShowKjdy09">
									<img src="@/assets/images/jingmai/kjdy08.png" />
									<div class="kjdy06icon" @click="showKjdy05"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy10">
									<img src="@/assets/images/jingmai/kjdy06.png" />
									<input type="text" class="kjdyinput" v-focus="true" @keyup.enter="showKjdy06">
									<div class="kjdy04icon" @click="showKjdy06"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy11">
									<img src="@/assets/images/jingmai/kjdy07.png" />
								</div>
								<!--输入/发货调出快捷短语-->
								<div class="kjdy" v-show="isShowKjdy12">
									<img src="@/assets/images/jingmai/kjdy04.png" />
									<div class="kjdy05icon">
										<el-input type="textarea" v-model="kjdytwo" class="kjdy01input"></el-input>
									</div>
								</div>
								<div class="kjdy" v-show="isShowKjdy13">
									<img src="@/assets/images/jingmai/kjdy09.png" />
									<div class="kjdy06icon" @click="showKjdy07"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy14">
									<img src="@/assets/images/jingmai/kjdy06.png" />
									<input type="text" class="kjdyinput" v-focus="true" @keyup.enter="showKjdy08">
									<div class="kjdy04icon" @click="showKjdy08"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy15">
									<img src="@/assets/images/jingmai/kjdy07.png" />
								</div>
								<!--新建-->
								<div class="kjdy" v-show="isShowKjdy16">
									<img src="@/assets/images/jingmai/kjdy01.png" />
									<div class="kjdy07icon" @mouseover="showKjdy09"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy17">
									<img src="@/assets/images/jingmai/kjdy10.png" />
									<div class="kjdy07icon" @click="showKjdy10"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy18">
									<img src="@/assets/images/jingmai/kjdy11.png" />
									<el-input type="textarea" class="kjdy02input" v-model="xjkjdy"></el-input>
									<div class="kjdy08icon" @click="showKjdy11"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy19">
									<img src="@/assets/images/jingmai/kjdy12.png" />
									<el-input type="textarea" class="kjdy02input" v-model="xjkjdy"></el-input>
									<el-input type="textarea" class="kjdy03input" v-model="fenzu"></el-input>
									<div class="kjdy09icon" @click="showKjdy12"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy20">
									<img src="@/assets/images/jingmai/kjdy11.png" />
									<el-input type="textarea" class="kjdy02input" v-model="xjkjdy"></el-input>
									<div class="kjdy10icon" @click="showKjdy13"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy21">
									<img src="@/assets/images/jingmai/kjdy13.png" />
									<el-input type="textarea" class="kjdy02input" v-model="xjkjdy"></el-input>
									<div class="kjdy11icon" @click="showKjdy14"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy22">
									<img src="@/assets/images/jingmai/kjdy14.png" />
									<el-input type="textarea" class="kjdy02input" v-model="xjkjdy"></el-input>
									<el-input type="textarea" class="kjdy04input" v-model="kjbm"></el-input>
									<div class="kjdy12icon" @click="showKjdy15"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy23">
									<img src="@/assets/images/jingmai/kjdy15.png" />
								</div>
							</div>
						</div>
						<div class="con-right">
							<h3>
								<span class="line"></span>
								提示
							</h3>
							<div v-if="isShowKjdyTip01">
								<p>导入快捷短语操作练习：</p>
								<p>请先下载下方的快捷短语表格，并保存在桌面上</p>
								<p><a @click="downloadKjdyFile">点击下载“快捷短语.csv”</a></p>
							</div>
							<p v-if="isShowKjdyTip02">请将下载好的快捷短语表格导入到京麦上</p>
							<p v-if="isShowKjdyTip03"><font color="red">鼠标左键</font>调出<font color="red">发货</font>的快捷短语，并发送</p>
							<p v-if="isShowKjdyTip04">在输入框输入“<font color="red">/16</font>”调出快捷短语，并发送</p>
							<p v-if="isShowKjdyTip05">在输入框输入“<font color="red">/发货</font>”调出快捷短语，并发送</p>
							<div v-if="isShowKjdyTip06">
								<p>新建一条催付的快捷短语：</p>
								<p>快捷短语内容：<font color="red">您好！您拍下的商品还未付款，请问您是有什么顾虑吗？</font></p>
								<p>新建快捷短语分组：<font color="red">催付</font></p>
								<p>快捷短语编码：<font color="red">催付</font></p>
							</div>
						</div>
					</div>
					<div id="studytip-five" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>实操通关，进入下一关吧</p>
							<p>
								<a class="startstudy" @click="studyNext('#tab-six', 6, 'six')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>
				<div id="tab-six-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'six'}">
					<div id="stoptip-six" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-six" class="content">
	          <div class="con-left">
	            <div class="zjgnbox">
	            	<div class="zjgn" v-show="isShowZjgn01">
	                <img src="@/assets/images/jingmai/zj01.png" />
	                <div class="zjgn01icon" @mouseover="showZjgn01"></div>
	              </div>
	              <div class="zjgn" v-show="isShowZjgn02">
	                <img src="@/assets/images/jingmai/zj02.png" />
	                <div class="zjgn01icon" @click="showZjgn02"></div>
	              </div>
	              <div class="zjgn" v-show="isShowZjgn03">
	                <img src="@/assets/images/jingmai/zj03.png" />
	                <div class="zjgn02icon" @click="showZjgn03"></div>
	              </div>
	              <div class="zjgn" v-show="isShowZjgn04">
	                <img src="@/assets/images/jingmai/zj04.png" />
	                <div class="zjgn03icon" @dblclick="showZjgn04"></div>
	              </div>
	              <div class="zjgn" v-show="isShowZjgn05">
	                <img src="@/assets/images/jingmai/zj05.png" />
	                <div class="zjgn04icon" @click="showZjgn05"></div>
	              </div>
	              <div class="zjgn" v-show="isShowZjgn06">
	                <img src="@/assets/images/jingmai/zj06.png" />
	                <div class="zjgn05icon" @click="showZjgn06"></div>
	              </div>
	              <div class="zjgn" v-show="isShowZjgn07">
	                <img src="@/assets/images/jingmai/zj07.png" />
	              </div>
	            </div>
	          </div>
	          <div class="con-right">
	            <h3>
	              <span class="line"></span>
	              提示
	            </h3>
	            <p>请根据聊天内容，将此顾客转接给状态为“<font color="red">在线</font>”的售后客服，并选择对应的<font color="red">转接原因</font></p>
	          </div>
	      	</div>
					<div id="studytip-six" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>实操通关，进入下一关吧</p>
							<p>
								<a class="startstudy" @click="studyNext('#tab-seven', 7, 'seven')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>
				<div id="tab-seven-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'seven'}">
					<div id="stoptip-seven" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>
	              <a class="startstudy" @click="startStudy">开始实操练习</a>
	            </p>
	          </div>
	        </div>
	        <div id="content-seven" class="content">
	          <div class="con-left">
	            <div class="cjgnbox">
	              <div class="cjgn" v-show="isShowCjgn01">
	                <img src="@/assets/images/jingmai/cj01.png" />
	                <div class="cjgn01icon" @mouseover="showCjgn01"></div>
	              </div>
	              <div class="cjgn" v-show="isShowCjgn02">
	                <img src="@/assets/images/jingmai/cj02.png" />
	                <div class="cjgn01icon" @click="showCjgn02"></div>
	              </div>
	              <div class="cjgn" v-show="isShowCjgn03">
	                <img src="@/assets/images/jingmai/cj03.png" />
	                <div class="cjgn02icon" @click="showCjgn03"></div>
	              </div>
	              <div class="cjgn" v-show="isShowCjgn04">
	                <img src="@/assets/images/jingmai/cj04.png" />
	              </div>
	              <div class="cjgn" v-show="isShowCjgn05">
	                <img src="@/assets/images/jingmai/cj05.png" />
	                <div class="cjgn03icon" @click="showCjgn04"></div>
	              </div>
	              <div class="cjgn" v-show="isShowCjgn06">
	                <img src="@/assets/images/jingmai/cj06.png" />
	                <div class="cjgn04icon" @click="showCjgn05"></div>
	              </div>
	              <div class="cjgn" v-show="isShowCjgn07">
	                <img src="@/assets/images/jingmai/cj07.png" />
	                <div class="cjgn05icon" @click="showCjgn06"></div>
	              </div>
	              <div class="cjgn" v-show="isShowCjgn08">
	                <img src="@/assets/images/jingmai/cj08.png" />
	              </div>
	              <div class="cjgn" v-show="isShowCjgn09">
	                <img src="@/assets/images/jingmai/cj06.png" />
	                <div class="cjgn06icon" @click="showCjgn07"></div>
	              </div>
	              <div class="cjgn" v-show="isShowCjgn10">
	                <img src="@/assets/images/jingmai/cj09.png" />
	                <div class="cjgn07icon" @click="showCjgn08"></div>
	              </div>
	              <div class="cjgn" v-show="isShowCjgn11">
	                <img src="@/assets/images/jingmai/cj10.png" />
	              </div>
	              <div class="cjgn" v-show="isShowCjgn12">
	                <img src="@/assets/images/jingmai/cj06.png" />
	                <div class="cjgn08icon" @click="showCjgn09"></div>
	              </div>
	              <div class="cjgn" v-show="isShowCjgn13">
	                <img src="@/assets/images/jingmai/cj11.png" />
	                <div class="cjgn09icon" @click="showCjgn10"></div>
	              </div>
	              <div class="cjgn" v-show="isShowCjgn14">
	                <img src="@/assets/images/jingmai/cj12.png" />
	              </div>
	              <div class="cjgn" v-show="isShowCjgn15">
	                <img src="@/assets/images/jingmai/cj06.png" />
	                <div class="cjgn10icon" @click="showCjgn11"></div>
	              </div>
	              <div class="cjgn" v-show="isShowCjgn16">
	                <img src="@/assets/images/jingmai/cj13.png" />
	                <div class="cjgn11icon" @click="showCjgn12"></div>
	              </div>
	              <div class="cjgn" v-show="isShowCjgn17">
	                <img src="@/assets/images/jingmai/cj14.png" />
	              </div>
	              <div class="cjgn" v-show="isShowCjgn18">
	                <img src="@/assets/images/jingmai/cj13.png" />
	                <div class="cjgn12icon" @click="showCjgn13"></div>
	              </div>
	              <div class="cjgn" v-show="isShowCjgn19">
	                <img src="@/assets/images/jingmai/cj15.png" />
	                <div class="cjgn13icon" @click="showCjgn14"></div>
	              </div>
	              <div class="cjgn" v-show="isShowCjgn20">
	                <img src="@/assets/images/jingmai/cj16.png" />
	              </div>
	          	</div>
	      		</div>
	          <div class="con-right">
	            <h3>
	              <span class="line"></span>
	              提示
	            </h3>
	            <p v-if="isShowCjgnTip01">请添加客服助手插件</p>
	            <p v-if="isShowCjgnTip02">请查看客户的商品浏览足迹，并推荐合适的商品</p>
	            <p v-if="isShowCjgnTip03">请发送符合客户需求的<font color="red">金</font>和<font color="red">银</font></p>
	            <p v-if="isShowCjgnTip04">请查看客户的购物车，并推荐合适的商品</p>
	            <p v-if="isShowCjgnTip05">请查看客户收藏关注的商品，并推荐合适的商品</p>
	            <p v-if="isShowCjgnTip06">请给客户推荐店铺销量最高，且符合客户需求的商品</p>
	            <p v-if="isShowCjgnTip07">请给客户推荐店铺评价最高，且符合客户需求的商品</p>
	          </div>
	        </div>
	        <div id="studytip-seven" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>实操通关，进入下一关吧</p>
	            <p>
	              <a class="startstudy" @click="studyNext('#tab-eight', 8, 'eight')">GO，下一关</a>
	            </p>
	          </div>
	        </div>
				</div>
				<div id="tab-eight-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'eight'}">
					<div id="stoptip-eight" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>
	              <a class="startstudy" @click="startStudy">开始实操练习</a>
	            </p>
	          </div>
	        </div>
	        <div id="content-eight" class="content">
	          <div class="con-left">
	            <div class="cjgnbox">
	              <div class="cjgn" v-show="isShowCjgnx01">
	                <img src="@/assets/images/jingmai/cjx01.png" />
	                <div class="cjgnx01icon" @click="showCjgnx01"></div>
	            	</div>
	            	<div class="cjgn" v-show="isShowCjgnx02">
	                <img src="@/assets/images/jingmai/cjx02.png" />
	                <el-input type="textarea" v-model="yunfei" class="cjgnx01input"></el-input>
	                <div class="cjgnx02icon" @click="showCjgnx02"></div>
	            	</div>
	            	<div class="cjgn" v-show="isShowCjgnx03">
	                <img src="@/assets/images/jingmai/cjx03.png" />
	            	</div>
	            	<div class="cjgn" v-show="isShowCjgnx04">
	                <img src="@/assets/images/jingmai/cjx04.png" />
	                <div class="cjgnx03icon" @click="showCjgnx03"></div>
	            	</div>
	            	<div class="cjgn" v-show="isShowCjgnx05">
	                <img src="@/assets/images/jingmai/cjx05.png" />
	                <el-input type="textarea" v-model="dizhi" class="cjgnx02input"></el-input>
	                <div class="cjgnx04icon" @click="showCjgnx04"></div>
	            	</div>
	            	<div class="cjgn" v-show="isShowCjgnx06">
	                <img src="@/assets/images/jingmai/cjx06.png" />
	                <div class="cjgnx05icon" @click="showCjgnx05"></div>
	            	</div>
	            	<div class="cjgn" v-show="isShowCjgnx07">
	                <img src="@/assets/images/jingmai/cjx07.png" />
	            	</div>
								<div class="cjgn" v-show="isShowCjgnx08">
	                <img src="@/assets/images/jingmai/cjx06.png" />
	                <div class="cjgnx06icon" @click="showCjgnx06"></div>
	            	</div>
	            	<div class="cjgn" v-show="isShowCjgnx09">
	                <img src="@/assets/images/jingmai/cjx08.png" />
	            	</div>
	            	<div class="cjgn" v-show="isShowCjgnx10">
	                <img src="@/assets/images/jingmai/cjx09.png" />
	                <div class="cjgnx07icon" @click="showCjgnx07"></div>
	            	</div>
	            	<div class="cjgn" v-show="isShowCjgnx11">
	                <img src="@/assets/images/jingmai/cjx10.png" />
	                <el-input type="textarea" v-model="beizhu" class="cjgnx03input"></el-input>
	                <div class="cjgnx08icon" @click="showCjgnx08"></div>
	            	</div>
	            	<div class="cjgn" v-show="isShowCjgnx12">
	                <img src="@/assets/images/jingmai/cjx11.png" />
	                <el-input type="textarea" v-model="beizhu" class="cjgnx03input"></el-input>
	                <div class="cjgnx09icon" @click="showCjgnx09"></div>
	            	</div>
	            	<div class="cjgn" v-show="isShowCjgnx13">
	                <img src="@/assets/images/jingmai/cjx12.png" />
	              </div>
	            </div>
	          </div>
	          <div class="con-right">
	            <h3>
	              <span class="line"></span>
	              提示
	            </h3>
	            <p v-if="isShowCjgnxTip01"><font color="red">待付款</font>的订单可以修改运费。请阅读聊天内容，修改运费金额</p>
	            <p v-if="isShowCjgnxTip02"><font color="red">待出库</font>的订单，可以修改客户收货信息。请根据聊天内容，修改客户收货信息<font color="red">（注意：如果提示输入的内容不正确，那就是地址的省、市、区、街道重复了）</font></p>
	            <p v-if="isShowCjgnxTip03">请和客户核对<font color="red">收货信息</font></p>
	            <p v-if="isShowCjgnxTip04">请和客户核对<font color="red">订单信息</font></p>
	            <p v-if="isShowCjgnxTip05">假设店铺规定有关发票的备注，等级为<font color="red">1级</font>；有关顺丰快递的备注，等级为<font color="red">2级</font>。请根据聊天内容，给此客户添加对应的<font color="red">订单备注</font></p>
	            <p v-if="isShowCjgnxTip06">请编辑备注内容为：<font color="red">要纸质发票</font>，并选择对应的等级</p>
	          </div>
	      	</div>
	        <div id="studytip-eight" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>实操通关，进入下一关吧</p>
	            <p>
	              <a class="startstudy" @click="studyNext('#tab-nine', 9, 'nine')">GO，下一关</a>
	            </p>
	          </div>
	        </div>
				</div>
				<div id="tab-nine-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'nine'}">
					<div id="stoptip-nine" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>
	              <a class="startstudy" @click="startStudy">开始实操练习</a>
	            </p>
	          </div>
	        </div>
	        <div id="content-nine" class="content">
	          <div class="con-left">
	            <div class="tcjmbox">
	              <div class="tcjm" v-show="isShowTcjm01">
	                <img src="@/assets/images/jingmai/tc01.png" />
	                <div class="tcjm01icon" @click="showTcjm01"></div>
	              </div>
	              <div class="tcjm" v-show="isShowTcjm02">
	                <img src="@/assets/images/jingmai/tc02.png" />
	                <div class="tcjm02icon" @click="showTcjm02"></div>
	              </div>
	              <div class="tcjm" v-show="isShowTcjm03">
	                <img src="@/assets/images/jingmai/tc03.png" />
	                <div class="tcjm03icon" @click="showTcjm03"></div>
	              </div>
	              <div class="tcjm" v-show="isShowTcjm04">
	                <img src="@/assets/images/jingmai/tc04.png" />
	                <div class="tcjm04icon" @click="showTcjm04"></div>
	              </div>
	              <div class="tcjm" v-show="isShowTcjm05">
	                <img src="@/assets/images/jingmai/tc05.png" />
	                <div class="tcjm05icon" @contextmenu.prevent="showTcjm05"></div>
	                <img v-show="isShowTcjm06" class="tcjmImg" src="@/assets/images/jingmai/tc06.png" />
	                <div v-show="isShowTcjm06" class="tcjm06icon" @click="showTcjm06"></div>
	              </div>
	              <div class="tcjm" v-show="isShowTcjm07">
	                <img src="@/assets/images/jingmai/tc07.png" />
	              </div>
	            </div>
	          </div>
	          <div class="con-right">
	            <h3>
	              <span class="line"></span>
	              提示
	            </h3>
	            <p v-if="isShowTcjmTip01">请将状态切换为“<font color="red">离线</font>”</p>
	            <p v-if="isShowTcjmTip02">请关闭接待中心</p>
	            <p v-if="isShowTcjmTip03">请在右下角找到京麦的图标，并退出京麦</p>
	          </div>
	        </div>
	        <div id="studytip-nine" class="stoptip"  v-if="OnInline=='false'">
	          <div class="tip" style="width: 400px;height: 270px;">
	            <span class="el-icon-success"></span>
	            <p style="padding-bottom: 5px;">恭喜您完成所有训练，获得系统实操徽章。</p>
	            <p style="padding: 5px 0;">接下来请继续完成，</p>
	            <p style="padding: 5px 0;">淘金云客服app上的其他课程。</p>
	          </div>
	        </div>
				</div>
			</div>
		</div>
	 </div>
</template>

<script>
export default {
  data() {
    return {
    	tabCurrent: 'first',
		OnInline:'false',//小助手跳转
    	//第1步
    	isShowQnIcon: true, //是否显示图标
    	isShowQnIcon2: false, //显示点击图标后图片
      isShowLoginImg: false, //是否显示登录图片
      name: '', //登录账号
     	password: '', //密码
     	showPassword: false, //显示账号密码
     	isShowMimaImg: false, //显示记住密码
     	isShowRnd: false, //显示获取随机码
     	rnd: '', //随机密码
     	showRnd: false, //显示随机码
     	isShowLoginIndex: false, //显示登录后图片
     	isShowLoginIndexTwo: false, //显示接待中心
     	//第2步
     	showGqImg: false, //显示切换挂起图片
     	isShowWgq: false, //显示未挂起图片
     	//第3步
     	isShowOne: true, //显示排序1
     	isShowTwo: false, //显示排序2
     	isShowThree: false, //显示排序3
     	isShowFour: false, //显示排序4
     	isShowFive: false, //显示排序5
     	isShowSix: false, //显示数据
     	//第4步
     	zdhf: '', //自动回复输入框
     	isShowZdhficon: true,
     	isShowZdhf01: false,
     	isShowZdhf02: false,
     	isShowZdhf03: false,
     	isShowZdhf04: false,
     	isShowZdhf05: false,
     	isShowZdhf06: false,
     	isShowZdhf07: false,
     	isShowZdhf08: false,
     	//第5步
     	kjdy: '', //快捷编码输入框-16
     	kjdytwo: '', //快捷编码输入框-发货
     	xjkjdy: '', //新建快捷短语
     	fenzu: '', //分组名称
     	kjbm: '', //快捷编码
     	downCount: 0, //是否点击下载csv
     	isShowKjdy01: true,
     	isShowKjdy02: false,
     	isShowKjdy03: false,
     	isShowKjdy04: false,
     	isShowKjdy05: false,
     	isShowKjdy06: false,
     	isShowKjdy07: false,
     	isShowKjdy08: false,
     	isShowKjdy09: false,
     	isShowKjdy10: false,
     	isShowKjdy11: false,
     	isShowKjdy12: false,
     	isShowKjdy13: false,
     	isShowKjdy14: false,
     	isShowKjdy15: false,
     	isShowKjdy16: false,
     	isShowKjdy17: false,
     	isShowKjdy18: false,
     	isShowKjdy19: false,
     	isShowKjdy20: false,
     	isShowKjdy21: false,
     	isShowKjdy22: false,
     	isShowKjdy23: false,
     	isShowKjdyTip01: true,
     	isShowKjdyTip02: false,
      isShowKjdyTip03: false,
      isShowKjdyTip04: false,
      isShowKjdyTip05: false,
      isShowKjdyTip06: false,
      //第6步
     	isShowZjgn01: true,
     	isShowZjgn02: false,
     	isShowZjgn03: false,
     	isShowZjgn04: false,
      isShowZjgn05: false,
      isShowZjgn06: false,
      isShowZjgn07: false,
      //第7步上
      isShowCjgn01: true,
      isShowCjgn02: false,
      isShowCjgn03: false,
      isShowCjgn04: false,
      isShowCjgn05: false,
      isShowCjgn06: false,
      isShowCjgn07: false,
      isShowCjgn08: false,
      isShowCjgn09: false,
      isShowCjgn10: false,
      isShowCjgn11: false,
      isShowCjgn12: false,
      isShowCjgn13: false,
      isShowCjgn14: false,
      isShowCjgn15: false,
      isShowCjgn16: false,
      isShowCjgn17: false,
      isShowCjgn18: false,
      isShowCjgn19: false,
      isShowCjgn20: false,
      isShowCjgnTip01: true,
      isShowCjgnTip02: false,
      isShowCjgnTip03: false,
      isShowCjgnTip04: false,
      isShowCjgnTip05: false,
      isShowCjgnTip06: false,
      isShowCjgnTip07: false,
      //第7步下
      yunfei: '',
      dizhi: '',
      beizhu: '',
      isShowCjgnx01: true,
      isShowCjgnx02: false,
      isShowCjgnx03: false,
      isShowCjgnx04: false,
      isShowCjgnx05: false,
      isShowCjgnx06: false,
      isShowCjgnx07: false,
      isShowCjgnx08: false,
      isShowCjgnx09: false,
      isShowCjgnx10: false,
      isShowCjgnx11: false,
      isShowCjgnx12: false,
      isShowCjgnx13: false,
      isShowCjgnxTip01: true,
      isShowCjgnxTip02: false,
      isShowCjgnxTip03: false,
      isShowCjgnxTip04: false,
      isShowCjgnxTip05: false,
      isShowCjgnxTip06: false,
      //第8步
     	isShowTcjm01: true,
     	isShowTcjm02: false,
     	isShowTcjm03: false,
     	isShowTcjm04: false,
     	isShowTcjm05: false,
     	isShowTcjm06: false,
     	isShowTcjm07: false,
     	isShowTcjm08: false,
     	isShowTcjm09: false,
     	isShowTcjm10: false,
     	isShowTcjmTip01: true,
     	isShowTcjmTip02: false,
     	isShowTcjmTip03: false
    }
  },
  mounted() {
  	$('#stoptip-'+this.tabCurrent).show();
  	this.initAll();
  },
  watch: {
  	kjdy: function() {
  		if(this.kjdy == '/16') {
  			this.isShowKjdy08 = false;
  			this.isShowKjdy09 = true;
  		}
  	},
  	kjdytwo: function() {
  		if(this.kjdytwo == '/发货') {
  			this.isShowKjdy12 = false;
  			this.isShowKjdy13 = true;
  		}
  	}
  },
  directives: {
    focus: {
      inserted: function(el, {value}) {
        if(value){
          el.focus();
        }
      }
    }
  },
  created(){
	  if(this.$route.query.OnInline){
		 this.OnInline=this.$route.query.OnInline  
	  }
  },
  methods: {
  	formatDate: function (value) {
	    let date = new Date(value);
	    let y = date.getFullYear();
	    let MM = date.getMonth() + 1;
	    MM = MM < 10 ? ('0' + MM) : MM;
	    let d = date.getDate();
	    d = d < 10 ? ('0' + d) : d;
	    let h = date.getHours();
	    h = h < 10 ? ('0' + h) : h;
	    let m = date.getMinutes();
	    m = m < 10 ? ('0' + m) : m;
	    let s = date.getSeconds();
	    s = s < 10 ? ('0' + s) : s;
	    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
	  },
	  //第1步-开始播放视频
	  startVideo() {
	  	document.getElementById('first').play();
	  	$('#startvideo').hide();
	  },
	  //初始化第1步状态值
    initFirst() {
    	this.name = '';
    	this.password = '';
    	this.rnd = '';
    	this.isShowQnIcon = true;
    	this.isShowQnIcon2 = false;
    	this.isShowLoginImg = false;
    	this.showPassword = false;
    	this.isShowMimaImg = false;
    	this.isShowRnd = false;
    	this.showRnd = false;
    	this.isShowLoginIndex = false;
    	this.isShowLoginIndexTwo = false;
    },
    //初始化第2步状态值
    initSecond() {
    	this.showGqImg = false;
     	this.isShowWgq = false;
    },
    //初始化第3步状态值
    initThird() {
     	this.isShowOne = true;
     	this.isShowTwo = false;
     	this.isShowThree = false;
     	this.isShowFour = false;
     	this.isShowFive = false;
     	this.isShowSix = false;
    },
    //初始化第4步状态值
    initFour() {
    	this.zdhf = '';
     	this.isShowZdhficon = true;
     	this.isShowZdhf01 = false;
     	this.isShowZdhf02 = false;
     	this.isShowZdhf03 = false;
     	this.isShowZdhf04 = false;
     	this.isShowZdhf05 = false;
     	this.isShowZdhf06 = false;
     	this.isShowZdhf07 = false;
     	this.isShowZdhf08 = false;
    },
    //初始化第5步状态值
    initFive() {
    	this.kjdy = '';
    	this.kjdytwo = '';
    	this.xjkjdy = '';
    	this.fenzu = '';
     	this.downCount = 0;
     	this.isShowKjdy01 = true;
     	this.isShowKjdy02 = false;
     	this.isShowKjdy03 = false;
     	this.isShowKjdy04 = false;
     	this.isShowKjdy05 = false;
     	this.isShowKjdy06 = false;
     	this.isShowKjdy07 = false;
     	this.isShowKjdy08 = false;
     	this.isShowKjdy09 = false;
     	this.isShowKjdy10 = false;
     	this.isShowKjdy11 = false;
     	this.isShowKjdy12 = false;
     	this.isShowKjdy13 = false;
     	this.isShowKjdy14 = false;
     	this.isShowKjdy15 = false;
     	this.isShowKjdy16 = false;
     	this.isShowKjdy17 = false;
     	this.isShowKjdy18 = false;
     	this.isShowKjdy19 = false;
     	this.isShowKjdy20 = false;
     	this.isShowKjdy21 = false;
     	this.isShowKjdy22 = false;
     	this.isShowKjdy23 = false;
     	this.isShowKjdyTip01 = true;
     	this.isShowKjdyTip02 = false;
     	this.isShowKjdyTip03 = false;
     	this.isShowKjdyTip04 = false;
     	this.isShowKjdyTip05 = false;
    },
    //初始化第6步状态值
    initSix() {
    	this.isShowZjgn01 = true;
     	this.isShowZjgn02 = false;
     	this.isShowZjgn03 = false;
     	this.isShowZjgn04 = false;
     	this.isShowZjgn05 = false;
     	this.isShowZjgn06 = false;
     	this.isShowZjgn07 = false;
    },
    //初始化第7步上状态值
    initSeven() {
     	this.isShowCjgn01 = true;
     	this.isShowCjgn02 = false;
     	this.isShowCjgn03 = false;
     	this.isShowCjgn04 = false;
     	this.isShowCjgn05 = false;
      this.isShowCjgn06 = false;
      this.isShowCjgn07 = false;
      this.isShowCjgn08 = false;
      this.isShowCjgn09 = false;
      this.isShowCjgn10 = false;
      this.isShowCjgn11 = false;
      this.isShowCjgn12 = false;
      this.isShowCjgn13 = false;
      this.isShowCjgn14 = false;
      this.isShowCjgn15 = false;
      this.isShowCjgn16 = false;
      this.isShowCjgn17 = false;
      this.isShowCjgn18 = false;
      this.isShowCjgn19 = false;
      this.isShowCjgn20 = false;
      this.isShowCjgnTip01 = true;
      this.isShowCjgnTip02 = false;
      this.isShowCjgnTip03 = false;
      this.isShowCjgnTip04 = false;
      this.isShowCjgnTip05 = false;
      this.isShowCjgnTip06 = false;
      this.isShowCjgnTip07 = false;
    },
    //初始化第7步下状态值
    initEight() {
     	this.yunfei = '';
     	this.dizhi = '';
     	this.beizhu = '';
     	this.isShowCjgnx01 = true;
     	this.isShowCjgnx02 = false;
     	this.isShowCjgnx03 = false;
     	this.isShowCjgnx04 = false;
     	this.isShowCjgnx05 = false;
     	this.isShowCjgnx06 = false;
     	this.isShowCjgnx07 = false;
     	this.isShowCjgnx08 = false;
     	this.isShowCjgnx09 = false;
     	this.isShowCjgnx10 = false;
     	this.isShowCjgnx11 = false;
     	this.isShowCjgnx12 = false;
     	this.isShowCjgnx13 = false;
     	this.isShowCjgnxTip01 = true;
     	this.isShowCjgnxTip02 = false;
     	this.isShowCjgnxTip03 = false;
     	this.isShowCjgnxTip04 = false;
     	this.isShowCjgnxTip05 = false;
     	this.isShowCjgnxTip06 = false;
    },
    //初始化第8步状态值
    initNine() {
     	this.isShowTjgnicon = true
     	this.isShowTjgn01 = false
     	this.isShowTjgn02 = false
     	this.isShowTjgn03 = false
     	this.isShowTjgn04 = false
     	this.isShowTjgn05 = false
     	this.isShowTjgn06 = false
    },
  	//初始化所有tab内容
  	initAll() {
    	//第1步
    	this.initFirst();
     	//第2步
     	this.initSecond();
     	//第3步
     	this.initThird();
     	//第4步
     	this.initFour();
     	//第5步
     	this.initFive();
     	//第6步
      this.initSix();
      //第7步上
      this.initSeven();
      //第7步下
      this.initEight();
      //第9步
      this.initNine();
  	},
    //开始实操练习
    startStudy() {
    	$('#stoptip-'+this.tabCurrent).hide();
    	$('#content-'+this.tabCurrent).show();
    	this.addRecord('START', 1);
    },
    //下一关
    studyNext(next, index, tabCurrent) {
    	$('.el-tabs__header').find('.js-tab').each(function() {
    		$(this).removeClass('is-active');
    	});
    	$(next).addClass('is-active');
    	$('.el-tabs__content').find('.el-tab-pane').each(function() {
    		$(this).hide();
    	});
    	$(next+'-content').show();
    	this.tabCurrent = tabCurrent;
    	this.addRecord('START', index);
    },
    //第1步-单击图标
    showLoginImg() {
    	this.isShowQnIcon = false;
    	this.isShowQnIcon2 = true;
    },
    //双击图标
    showLoginImg2() {
    	this.isShowQnIcon2 = false;
    	this.isShowLoginImg = true;
    },
    //登录
    loginIn() {
      if(this.name == '') {
        this.$notify({
          message: '请输入账号',
          duration: 2000
        });
        return;
      }else if(this.name != '淘金客服:002') {
        this.$notify({
      		dangerouslyUseHTMLString: true,
          message: '<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>',
          duration: 2000
        });
        return;
      }
      if(this.password == '') {
        this.$notify({
          message: '请输入密码',
          duration: 2000
        });
        return;
      }else if(this.password != 'TJ2022') {
        this.$notify({
      		dangerouslyUseHTMLString: true,
          message: '<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>',
          duration: 2000
        });
        return;
      }
      if(!this.isShowMimaImg) {
      	this.$notify({
          message: '请勾选记住密码',
          duration: 2000
        });
        return;
      }
      this.isShowLoginImg = false;
      this.isShowMimaImg = false;
      this.isShowRnd = true;
    },
    //验证码登录
    loginInRnd() {
    	if(this.rnd == '') {
        this.$notify({
          message: '请输入短信验证码',
          duration: 2000
        });
        return;
      }else if(this.rnd != '6022') {
        this.$notify({
          message: '短信验证码错误',
          duration: 2000
        });
        return;
      }
      this.isShowRnd = false;
      this.isShowLoginIndex = true;
    },
    //进入接待中心
    enterJd() {
    	var self = this;
    	this.isShowLoginIndex = false;
    	this.isShowLoginIndexTwo = true;
    	this.addRecord('END', 1);
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第2步-切换状态-显示未挂起图片
    showWgqImg() {
    	var self = this;
    	this.showGqImg = false;
    	this.isShowWgq = true;
    	this.addRecord('END', 2);
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第3步-排序
    showPaixuImgOne() {
    	this.isShowOne = false;
    	this.isShowTwo = true;
    },
    showPaixuImgTwo() {
    	this.isShowTwo = false;
    	this.isShowThree = true;
    },
    showPaixuImgThree() {
    	this.isShowThree = false;
    	this.isShowFour = true;
    },
    showPaixuImgFour() {
    	this.isShowFour = false;
    	this.isShowFive = true;
    },
    showPaixuImgFive() {
    	let self = this;
    	this.isShowFive = false;
    	this.isShowSix = true;
    	this.addRecord('END', 3)
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第4步-自动回复
    showZdhf01() {
    	this.isShowZdhficon = false;
    	this.isShowZdhf01 = true;
    },
    showZdhf02() {
    	this.isShowZdhf01 = false;
    	this.isShowZdhf02 = true;
    },
    showZdhf03() {
    	this.isShowZdhf02 = false;
    	this.isShowZdhf03 = true;
    },
    showZdhf04() {
    	this.isShowZdhf03 = false;
    	this.isShowZdhf04 = true;
    },
    showZdhf05() {
    	this.isShowZdhf04 = false;
    	this.isShowZdhf05 = true;
    },
    showZdhf06() {
    	this.isShowZdhf05 = false;
    	this.isShowZdhf06 = true;
    },
    showZdhf07() {
    	this.isShowZdhf06 = false;
    	this.isShowZdhf07 = true;
    },
    showZdhf08() {
    	let self = this;
    	if(this.zdhf != '您好！欢迎光临，请问有什么可以帮到您？') {
        this.$notify({
          message: '请输入正确的回复内容',
          duration: 2000
        });
        return;
      }
    	this.isShowZdhf07 = false;
    	this.isShowZdhf08 = true;
    	this.addRecord('END', 4);
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第5步-快捷短语
    showKjdy01() {
    	if(this.downCount == 0) {
    		this.$notify({
          message: '请先下载快捷短语模板',
          duration: 2000
        });
    		return false;
    	}
    	this.isShowKjdy01 = false;
    	this.isShowKjdy02 = true;
    	this.isShowKjdyTip01 = false;
    	this.isShowKjdyTip02 = true;
    },
    downloadKjdyFile() {
    	this.downCount = 1;
    	// window.open('//res.study.itaojin.cn/jingmai/快捷短语.csv');
		 let path = '//res.study.itaojin.cn/jingmai/快捷短语.csv'
      const downloadRes = async () => {
          let response = await fetch(path); 
          let blob = await response.blob();  
          let objectUrl = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = objectUrl;
          a.download = '快捷短语.csv';
          a.click()
          a.remove(); 
       }
      downloadRes();
        this.isShowKjdyTip01 = false
        this.isShowKjdyTip02 = true
    },
    tirggerFile($event) {
    	let self = this;
      var file = $event.target.files;
    	if(!file[0] || file[0] && file[0].name.indexOf('快捷短语')<0) {
    		this.$notify({
          message: '请选择你下载的“快捷短语.csv”模板文件',
          duration: 2000
        });
    		return false;
    	}
    	self.isShowKjdy02 = false;
  		self.isShowKjdy03 = true;
  		self.$notify({
        message: '快捷短语导入练习完成，下一步快捷短语调出练习',
        duration: 2000
      });
      setTimeout(function() {
        self.isShowKjdy03 = false;
    		self.isShowKjdy04 = true;
    		self.isShowKjdyTip02 = false;
    		self.isShowKjdyTip03 = true;
      }, 2000);
    },
    showKjdy02() {
    	this.isShowKjdy04 = false;
    	this.isShowKjdy05 = true;
    },
    showKjdy03() {
    	this.isShowKjdy05 = false;
    	this.isShowKjdy06 = true;
    },
    showKjdy04() {
    	let self = this;
    	self.isShowKjdy06 = false;
    	self.isShowKjdy07 = true;
    	setTimeout(function() {
        self.isShowKjdy07 = false;
    		self.isShowKjdy08 = true;
    		self.isShowKjdyTip03 = false;
    		self.isShowKjdyTip04 = true;
      }, 2000);
    },
    showKjdy05() {
    	this.kjdy = '';
    	this.isShowKjdy09 = false;
    	this.isShowKjdy10 = true;
    },
    showKjdy06() {
    	let self = this;
    	this.isShowKjdy10 = false;
    	this.isShowKjdy11 = true;
    	setTimeout(function() {
        self.isShowKjdy11 = false;
    		self.isShowKjdy12 = true;
    		self.isShowKjdyTip04 = false;
    		self.isShowKjdyTip05 = true;
      }, 2000);
    },
    showKjdy07() {
    	this.kjdytwo = '';
    	this.isShowKjdy13 = false;
    	this.isShowKjdy14 = true;
    },
    showKjdy08() {
    	let self = this;
    	this.isShowKjdy14 = false;
    	this.isShowKjdy15 = true;
    	setTimeout(function() {
        self.isShowKjdy15 = false;
    		self.isShowKjdy16 = true;
    		self.isShowKjdyTip05 = false;
    		self.isShowKjdyTip06 = true;
      }, 2000);
    },
    showKjdy09() {
    	this.isShowKjdy16 = false;
    	this.isShowKjdy17 = true;
    },
    showKjdy10() {
    	this.isShowKjdy17 = false;
    	this.isShowKjdy18 = true;
    },
    showKjdy11() {
    	if(this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
    		this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
    		return false;
    	}
    	this.isShowKjdy18 = false;
    	this.isShowKjdy19 = true;
    },
    showKjdy12() {
    	if(this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
    		this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
    		return false;
    	}
    	if(this.fenzu != '催付') {
    		this.$notify({
          message: '请输入正确的快捷短语分组名称',
          duration: 2000
        });
    		return false;
    	}
    	this.isShowKjdy19 = false;
    	this.isShowKjdy20 = true;
    },
    showKjdy13() {
    	if(this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
    		this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
    		return false;
    	}
    	this.isShowKjdy20 = false;
    	this.isShowKjdy21 = true;
    },
    showKjdy14() {
    	if(this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
    		this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
    		return false;
    	}
    	this.isShowKjdy21 = false;
    	this.isShowKjdy22 = true;
    },
    showKjdy15() {
    	let self = this;
    	if(this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
    		this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
    		return false;
    	}
    	if(this.kjbm != '催付') {
    		this.$notify({
          message: '请输入正确的快捷短语编码',
          duration: 2000
        });
    		return false;
    	}
    	this.isShowKjdy22 = false;
    	this.isShowKjdy23 = true;
    	this.addRecord('END', 5);
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第6步-转接
    showZjgn01() {
    	this.isShowZjgn01 = false;
    	this.isShowZjgn02 = true;
    },
    showZjgn02() {
    	this.isShowZjgn02 = false;
    	this.isShowZjgn03 = true;
    },
    showZjgn03() {
    	this.isShowZjgn03 = false;
    	this.isShowZjgn04 = true;
    },
    showZjgn04() {
    	this.isShowZjgn04 = false;
    	this.isShowZjgn05 = true;
    },
    showZjgn05() {
    	this.isShowZjgn05 = false;
    	this.isShowZjgn06 = true;
    },
    showZjgn06() {
    	let self = this;
    	this.isShowZjgn06 = false;
    	this.isShowZjgn07 = true;
    	this.addRecord('END', 6);
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第7步-插件功能上
    showCjgn01() {
    	this.isShowCjgn01 = false;
    	this.isShowCjgn02 = true;
    },
    showCjgn02() {
    	this.isShowCjgn02 = false;
    	this.isShowCjgn03 = true;
    },
    showCjgn03() {
    	let self = this;
    	this.isShowCjgn03 = false;
    	this.isShowCjgn04 = true;
    	setTimeout(function() {
        self.isShowCjgn04 = false;
    		self.isShowCjgn05 = true;
    		self.isShowCjgnTip01 = false;
    		self.isShowCjgnTip02 = true;
      }, 2000);
    },
    showCjgn04() {
    	this.isShowCjgn05 = false;
    	this.isShowCjgn06 = true;
    	this.isShowCjgnTip02 = false;
    	this.isShowCjgnTip03 = true;
    },
    showCjgn05() {
    	this.isShowCjgn06 = false;
    	this.isShowCjgn07 = true;
    },
    showCjgn06() {
    	let self = this;
    	this.isShowCjgn07 = false;
    	this.isShowCjgn08 = true;
    	setTimeout(function() {
        self.isShowCjgn08 = false;
    		self.isShowCjgn09 = true;
    		self.isShowCjgnTip03 = false;
    		self.isShowCjgnTip04 = true;
      }, 2000);
    },
    showCjgn07() {
    	this.isShowCjgn09 = false;
    	this.isShowCjgn10 = true;
    },
    showCjgn08() {
    	let self = this;
    	this.isShowCjgn10 = false;
    	this.isShowCjgn11 = true;
    	setTimeout(function() {
        self.isShowCjgn11 = false;
    		self.isShowCjgn12 = true;
    		self.isShowCjgnTip04 = false;
    		self.isShowCjgnTip05 = true;
      }, 2000);
    },
    showCjgn09() {
    	this.isShowCjgn12 = false;
    	this.isShowCjgn13 = true;
    },
    showCjgn10() {
    	let self = this;
    	this.isShowCjgn13 = false;
    	this.isShowCjgn14 = true;
    	setTimeout(function() {
        self.isShowCjgn14 = false;
    		self.isShowCjgn15 = true;
    		self.isShowCjgnTip05 = false;
    		self.isShowCjgnTip06 = true;
      }, 2000);
    },
    showCjgn11() {
    	this.isShowCjgn15 = false;
    	this.isShowCjgn16 = true;
    },
    showCjgn12() {
    	let self = this;
    	this.isShowCjgn16 = false;
    	this.isShowCjgn17 = true;
    	setTimeout(function() {
        self.isShowCjgn17 = false;
    		self.isShowCjgn18 = true;
    		self.isShowCjgnTip06 = false;
    		self.isShowCjgnTip07 = true;
      }, 2000);
    },
    showCjgn13() {
    	this.isShowCjgn18 = false;
    	this.isShowCjgn19 = true;
    },
    showCjgn14() {
    	let self = this;
    	this.isShowCjgn19 = false;
    	this.isShowCjgn20 = true;
    	this.addRecord('END', 7);
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第7步-插件功能（下）
    showCjgnx01() {
    	this.isShowCjgnx01 = false;
    	this.isShowCjgnx02 = true;
    },
    showCjgnx02() {
    	let self = this;
    	if(this.yunfei != 15) {
    		this.$notify({
          message: '请输入正确的运费',
          duration: 2000
        });
    		return false;
    	}
    	this.isShowCjgnx02 = false;
    	this.isShowCjgnx03 = true;
    	setTimeout(function() {
        self.isShowCjgnx03 = false;
    		self.isShowCjgnx04 = true;
    		self.isShowCjgnxTip01 = false;
    		self.isShowCjgnxTip02 = true;
      }, 2000);
    },
    showCjgnx03() {
    	this.isShowCjgnx04 = false;
    	this.isShowCjgnx05 = true;
    },
    showCjgnx04() {
    	if(this.dizhi != '淘金云客服') {
    		this.$notify({
          message: '请输入正确的详细地址',
          duration: 2000
        });
    		return false;
    	}
    	this.isShowCjgnx05 = false;
    	this.isShowCjgnx06 = true;
    	this.isShowCjgnxTip02 = false;
    	this.isShowCjgnxTip03 = true;
    },
    showCjgnx05() {
    	let self = this;
    	this.isShowCjgnx06 = false;
    	this.isShowCjgnx07 = true;
    	setTimeout(function() {
        self.isShowCjgnx07 = false;
    		self.isShowCjgnx08 = true;
    		self.isShowCjgnxTip03 = false;
    		self.isShowCjgnxTip04 = true;
      }, 2000);
    },
    showCjgnx06() {
    	let self = this;
    	this.isShowCjgnx08 = false;
    	this.isShowCjgnx09 = true;
    	setTimeout(function() {
        self.isShowCjgnx09 = false;
    		self.isShowCjgnx10 = true;
    		self.isShowCjgnxTip04 = false;
    		self.isShowCjgnxTip05 = true;
      }, 2000);
    },
    showCjgnx07() {
    	this.isShowCjgnx10 = false;
    	this.isShowCjgnx11 = true;
    	this.isShowCjgnxTip05 = false;
    	this.isShowCjgnxTip06 = true;
    },
    showCjgnx08() {
    	if(this.beizhu != '要纸质发票') {
    		this.$notify({
          message: '请输入正确的备注',
          duration: 2000
        });
    		return false;
    	}
    	this.isShowCjgnx11 = false;
    	this.isShowCjgnx12 = true;
    },
    showCjgnx09() {
    	if(this.beizhu != '要纸质发票') {
    		this.$notify({
          message: '请输入正确的备注',
          duration: 2000
        });
    		return false;
    	}
    	this.isShowCjgnx12 = false;
    	this.isShowCjgnx13 = true;
    	let self = this;
    	this.addRecord('END', 8);
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第8步-退出京麦
    showTcjm01() {
    	this.isShowTcjm01 = false;
    	this.isShowTcjm02 = true;
    },
    showTcjm02() {
    	this.isShowTcjm02 = false;
      this.isShowTcjm03 = true;
      this.isShowTcjmTip01 = false;
      this.isShowTcjmTip02 = true;
    },
    showTcjm03() {
    	this.isShowTcjm03 = false;
      this.isShowTcjm04 = true;
      this.isShowTcjmTip02 = false;
      this.isShowTcjmTip03 = true;
      setTimeout(() => {
        var $left = $('.tcjm04icon').closest('.con-left');
        $left.scrollTop($left[0].scrollHeight);
      }, 100);
    },
    showTcjm04() {
    	this.isShowTcjm04 = false;
      this.isShowTcjm05 = true;
    },
    showTcjm05() {
    	this.isShowTcjm06 = true;
    },
    showTcjm06() {
    	this.isShowTcjm05 = false;
    	this.isShowTcjm06 = false;
    	this.isShowTcjm07 = true;
    	let self = this;
    	this.addRecord('END', 9);
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString (date, format) { // 时间格式化
      var date = new Date(date),
        o = {
          "M+" : date.getMonth() + 1,
          "d+" : date.getDate(),
          "h+" : date.getHours(),
          "m+" : date.getMinutes(),
          "s+" : date.getSeconds(),
          "q+" : Math.floor((date.getMonth() + 3) / 3),
          "S" : date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday(n){
      let lastDays = new Date().setDate((new Date().getDate() - n));
      let lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord(type, index) {
      var data = {
        exerciseType: 'JING_MAI_EXAM_11618',
        stepSeq: index,
        exerciseAction: type
      }
      this.$http.post(API_ROOT.newcustomer + '/simulationExercise/addRecord', data).then(res=> {
        var result = res.data
        if(result.success) {
          if(index==9 && type=='END'){
		    window.parent['goBack']();
		  }
        }else {
          this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          })
        }
      },res=> {
        this.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        })
      })
    }
  } 
}
</script>
<style lang="less" scoped>
.account-table {
  border-top: 1px solid #000000;
  border-left: 1px solid #000000;
  margin: 10px;
  border-spacing: inherit;
  > tr > td {
    border-right: 1px solid #000000;
    border-bottom: 1px solid #000000;
    padding: 5px;
  }
}
.mynone {
    display: none !important;
}
</style>


// WEBPACK FOOTER //
// ./src/page/simulate/jingMaiExam_11618.vue